import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography,
} from "@material-ui/core";
import { PayrollRenderRow } from "./PayrollRenderRow";
import { PAYROLL_TABLE_COLS } from "pages/Payroll/payrollTable";
import { PayrollRowData, PayrollUserData } from "types/Payroll";
import { formatNumberType } from "utils/formatNumbers";
import { useStyles } from "./styles";
import { FC } from "react";

interface PayrollRenderTableProps {
  type: "by_total" | "by_da";
  dataList: PayrollRowData[];
  userList: PayrollUserData[];
}

export const PayrollRenderTable: FC<PayrollRenderTableProps> = ({ type, dataList, userList }) => {
  const classes = useStyles();

  return (
    <Box id="tableXlsx">
      <Table style={{ zIndex: 999, background: "white", maxHeight: "60vh" }}>
        <TableHead className={classes.head}>
          <TableRow>
            {PAYROLL_TABLE_COLS?.map((item) => (
              <TableCell className={classes.headCell}>
                <Typography variant="h6">{item?.label}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {type === "by_total" ? (
          <TableBody>
            {dataList.length > 0
              ? dataList.map((row: PayrollRowData) => (
                  <PayrollRenderRow
                    user_name={row?.user_name}
                    badge={row?.badge}
                    station={row?.station}
                    agency={row?.agency}
                    date={row?.date}
                    role={row?.role}
                    role_hours={row?.role_hours}
                    pay_rate={row?.pay_rate}
                    pay={row?.pay}
                    agency_pay={row?.agency_pay}
                    comment={row?.comment}
                    is_total_table
                  />
                ))
              : null}
            {dataList.length > 0 ? (
              <PayrollRenderRow
                user_name={"Total hours:"}
                role_hours={dataList.reduce((a: any, c: PayrollRowData) => a + c.role_hours, 0)}
                pay={dataList.reduce((a: any, c: PayrollRowData) => a + c.pay, 0)}
                agency_pay={formatNumberType(
                  dataList.reduce((a: any, c: PayrollRowData) => a + c.agency_pay, 0),
                )}
                is_total_table
                is_total_row
              />
            ) : null}
          </TableBody>
        ) : (
          <>
            {userList.map((user) => {
              const userDataList = dataList.filter((report) => report.user_id === user.id);

              return (
                <TableBody>
                  {userDataList.length > 0
                    ? userDataList.map((row: PayrollRowData) => (
                        <PayrollRenderRow
                          user_name={row?.user_name}
                          badge={row?.badge}
                          station={row?.station}
                          agency={row?.agency}
                          date={row?.date}
                          role={row?.role}
                          role_hours={row?.role_hours}
                          pay_rate={row?.pay_rate}
                          pay={row?.pay}
                          agency_pay={row?.agency_pay}
                          comment={row?.comment}
                        />
                      ))
                    : null}
                  {userDataList.length > 0 ? (
                    <PayrollRenderRow
                      user_name={`${user.username} - Total hours:`}
                      badge={user.badge}
                      role_hours={userDataList.reduce(
                        (a: any, c: PayrollRowData) => a + c.role_hours,
                        0,
                      )}
                      pay_rate={user.rate}
                      pay={userDataList.reduce((a: any, c: PayrollRowData) => a + c.pay, 0)}
                      agency_pay={formatNumberType(
                        userDataList.reduce((a: any, c: PayrollRowData) => a + c.agency_pay, 0),
                      )}
                      is_total_row
                    />
                  ) : null}
                  {userList.length - 1 !== userList.findIndex((item) => item.id === user.id) && (
                    <PayrollRenderRow/>
                  )}
                </TableBody>
              );
            })}
          </>
        )}
      </Table>
    </Box>
  );
};
